module.exports = __webpack_public_path__ + "static/img/logo_c.f3717f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_c.png
// module id = aIog
// module chunks = 0